(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    const selector = '[data-product-description-read-more]';
    const textSelector = '.text-block--text_n7A9da';
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const ensureDescriptionPreview = () => {
      // Prefer the block ID from this product template, then fall back to the
      // text block inside the Description accordion in case Shopify changes IDs.
      let text = document.querySelector(textSelector);
      if (!text) {
        const descriptionDetails = [...document.querySelectorAll('accordion-custom details')].find((details) =>
          /description/i.test(details.querySelector('summary')?.textContent?.trim() || '')
        );
        text = descriptionDetails?.querySelector('.text-block');
      }
      if (!text || text.closest(selector)) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'product-description-read-more';
      wrapper.dataset.productDescriptionReadMore = '';
      wrapper.dataset.expanded = 'false';
      text.classList.add('product-description-read-more__text');

      if (!text.id) text.id = 'product-description-mobile-preview';
      text.parentNode.insertBefore(wrapper, text);
      wrapper.appendChild(text);

      const button = document.createElement('button');
      const isFrench = document.documentElement.lang.toLowerCase().startsWith('fr');
      const showMore = isFrench ? 'Afficher la suite' : 'Show more';
      const showLess = isFrench ? 'Afficher moins' : 'Show less';
      button.type = 'button';
      button.className = 'product-description-read-more__toggle';
      button.dataset.descriptionToggle = '';
      button.dataset.readMoreLabel = showMore;
      button.dataset.readLessLabel = showLess;
      button.setAttribute('aria-controls', text.id);
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', showMore);

      const icon = document.createElement('span');
      icon.className = 'svg-wrapper product-description-read-more__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '⌄';
      button.appendChild(icon);
      wrapper.appendChild(button);
    };

    const updateDescriptionPreviews = () => {
      ensureDescriptionPreview();
      document.querySelectorAll(selector).forEach((wrapper) => {
        const text = wrapper.querySelector('.product-description-read-more__text, .text-block--text_n7A9da, .text-block');
        if (!text) return;

        if (!mobileQuery.matches) {
          if (wrapper.dataset.expanded !== 'true') wrapper.dataset.overflow = 'false';
          return;
        }

        if (wrapper.dataset.expanded === 'true') {
          wrapper.dataset.overflow = 'true';
          return;
        }

        wrapper.removeAttribute('data-overflow');
        requestAnimationFrame(() => {
          if (!wrapper.isConnected) return;
          wrapper.dataset.overflow = text.scrollHeight > text.clientHeight + 1 ? 'true' : 'false';
        });
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-description-toggle]');
      if (!button) return;

      const wrapper = button.closest(selector);
      if (!wrapper) return;

      const expanded = button.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !expanded;
      wrapper.dataset.expanded = String(nextExpanded);
      wrapper.dataset.overflow = 'true';
      button.setAttribute('aria-expanded', String(nextExpanded));
      button.setAttribute('aria-label', nextExpanded ? button.dataset.readLessLabel : button.dataset.readMoreLabel);

      if (!nextExpanded) updateDescriptionPreviews();
    });

    const scheduleUpdate = () => requestAnimationFrame(updateDescriptionPreviews);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
    } else {
      scheduleUpdate();
    }
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    document.addEventListener('shopify:section:load', scheduleUpdate);
    mobileQuery.addEventListener?.('change', scheduleUpdate);
  })();

  } catch(e) { console.error(e); }
})();
})();
